import theme from '@/assets/theme';
import { themeT } from '@/utils/themeText';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface EmptyTransportProviderProps {
  image: string;
}

/**
 * Empty state component displayed when no transport providers exist.
 * Shows a message with a link to navigate to the courier settings page.
 *
 * @param image - Path to the empty state illustration image
 */
const EmptyTransportProvider: React.FC<EmptyTransportProviderProps> = ({
  image,
}) => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: 16, textAlign: 'center' }}>
      <img src={image} alt='' style={{ maxWidth: 120 }} />
      <div
        style={{
          marginTop: 8,
          fontWeight: 600,
          fontSize: 14,
          color: 'black',
        }}
      >
        {`No ${themeT('transportProvider', theme.themeType).toLowerCase()} exist yet.`}
      </div>
      <div
        style={{
          marginTop: 4,
          fontWeight: 600,
          fontSize: 14,
          color: 'black',
        }}
      >
        Add one{' '}
        <a
          style={{
            color: 'black',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={() => navigate('/settings/couriers')}
        >
          here
        </a>
        .
      </div>
    </div>
  );
};

export default EmptyTransportProvider;
